import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { customPalette } from '../themes/customTheme';
import { apiUrl, httpClient } from '../utils/httpUtils';

export const AutocompleteSelectFieldMembers = ({
  selectedMember,
  setSelectedMember,
  multiple = false,
  setPage,
  team_id = null,
}) => {
  const t = useTranslate();
  const [members, setMembers] = useState([]);

  const getMembers = async () => {
    try {
      const url = `${apiUrl}/members?size=800&role=redactor${team_id ? `&team_id=${team_id}` : ''}`;
      const res = await httpClient(url);
      if (res.status === 200) {
        const data = await res.json.data;
        setMembers(data);
      }
    } catch (error) {
      console.error('Failed to fetch metrics:', error);
    }
  };

  useEffect(() => {
    getMembers();
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Autocomplete
      multiple={multiple}
      id="checkboxes-tags-demo"
      options={members}
      disableCloseOnSelect
      getOptionLabel={option => option.username}
      value={selectedMember}
      noOptionsText="Sin resultados"
      onChange={(event, newValue) => {
        setPage(0);
        setSelectedMember(newValue);
      }}
      sx={{
        div: { borderRadius: '10px !important' },
        '.MuiAutocomplete-endAdornment': {
          display: 'flex',
          alignItems: 'center',
        },
        input: {
          fontSize: '14px',
          color: customPalette.greyDark,
        },
      }}
      renderOption={(props, option) => {
        const { key, ...optionProps } = props;
        return (
          <li
            key={key}
            {...optionProps}
            style={{ fontSize: '14px', color: customPalette.greyDark }}
          >
            {option.username}
          </li>
        );
      }}
      style={{
        width: 200,
        height: 45,
      }}
      renderInput={params => (
        <TextField
          {...params}
          variant="outlined"
          label={t('resources.score.list.fields.editor')}
          sx={{
            width: 190,
            height: 45,
            fontSize: '14px',

            legend: {
              position: 'absolute',
            },

            label: {
              marginTop: '-8px',

              '&.Mui-focused': {
                transform: 'translate(13px, 7px) scale(0.75) !important',
                color: customPalette.primary.main,
                fontWeight: 500,
              },
              '&.MuiInputLabel-shrink': {
                transform: 'translate(13px, 7px) scale(0.75)',
                color: customPalette.primary.main,
                fontWeight: 500,
              },
            },

            '.MuiOutlinedInput-root ': {
              paddingTop: '7px !important',
              paddingBottom: '0 !important',
              div: {
                paddingBottom: '4px !important',
              },
            },
          }}
        />
      )}
    />
  );
};
